import React from "react";
import "./index.less";

class permissionDescribe extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        // document.title = '权限列表';
        return (
            <div className="page_type_h5_select">
                <article id="PermissionDescribe">
                    <section>
                        <p>应用权限说明</p>
                        <p>本版本发布日期：2025年12月15日</p>
                        <p>本版本生效日期：2025年12月22日</p>
                        <ol style={{ paddingLeft: ".16rem" }}>
                            <li>
                                为保障远程慧联APP、小程序能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；
                            </li>
                            <li>
                                根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况；
                            </li>
                            <li>
                                请您知悉，我们为业务与产品的功能与安全需要，我们可能也会使用第三方SDK，这些第三方也可能会申请或使用相关操作系统权限；
                            </li>
                            <li>
                                在使用产品的过程中，您可能会使用第三方开发的H5页面，这些第三方开发开发的插件也可能因业务功能所必需而申请或使用相关操作系统权限。
                            </li>
                        </ol>
                    </section>

                    <div>
                        <div className="scorll-view">
                            <div className="table1">
                                <div className="table-view">
                                    <div className="table-clumn">序号</div>
                                    <div className="table-clumn">权限内容</div>
                                    <div className="table-clumn">使用场景</div>
                                    <div className="table-clumn">影响范围</div>
                                    <div className="table-clumn">管理路径</div>
                                    <div className="table-clumn">适用版本</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">1</div>
                                    <div className="table-clumn">相册</div>
                                    <div className="table-clumn">
                                        帮助您完成扫码充电、实名认证、绑定车辆、维保预约、在线客服和问题反馈、上传头像功能
                                    </div>
                                    <div className="table-clumn">
                                        如您关闭该权限，关闭后仅影响对应功能，但不影响您使用其他服务
                                    </div>
                                    <div className="table-clumn">
                                        我的-&gt;设置-&gt;隐私管理-&gt;允许照片权限访问
                                    </div>
                                    <div className="table-clumn">
                                        安卓、ios、HarmonyOS、小程序
                                    </div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">2</div>
                                    <div className="table-clumn">相机</div>
                                    <div className="table-clumn">
                                        帮助您完成扫码充电、实名认证、绑定车辆、维保预约、在线客服和问题反馈、二维码扫描、上传头像功能、扫车牌下单
                                    </div>
                                    <div className="table-clumn">
                                        如您关闭该权限，关闭后仅影响对应功能，但不影响您使用其他服务
                                    </div>
                                    <div className="table-clumn">
                                        我的-&gt;设置-&gt;隐私管理-&gt;允许相机权限访问
                                    </div>
                                    <div className="table-clumn">
                                        安卓、ios、HarmonyOS、小程序
                                    </div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">3</div>
                                    <div className="table-clumn">位置</div>
                                    <div className="table-clumn">
                                        帮助您查询附近电站、甲醇站、服务站、运营商、门店、维保预约、年审预约功能
                                    </div>
                                    <div className="table-clumn">
                                        如您关闭该权限，关闭后仅影响对应功能，但不影响您使用其他服务
                                    </div>
                                    <div className="table-clumn">
                                        我的-&gt;设置-&gt;隐私管理-&gt;允许位置权限访问
                                    </div>
                                    <div className="table-clumn">
                                        安卓、ios、HarmonyOS、小程序
                                    </div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">4</div>
                                    <div className="table-clumn">通知</div>
                                    <div className="table-clumn">
                                        接收充值、充电、消息、年审、保险或其它消息
                                    </div>
                                    <div className="table-clumn">
                                        如您关闭该权限，关闭后仅影响对应功能，但不影响您使用其他服务
                                    </div>
                                    <div className="table-clumn">
                                        我的-&gt;设置-&gt;隐私管理-&gt;允许通知权限访问
                                    </div>
                                    <div className="table-clumn">安卓、ios</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">5</div>
                                    <div className="table-clumn">通讯录</div>
                                    <div className="table-clumn">
                                        帮助您完成车辆安全数据授权给其他手机号用户的功能
                                    </div>
                                    <div className="table-clumn">
                                        如您关闭该权限，关闭后仅影响对应功能，但不影响您使用其他服务
                                    </div>
                                    <div className="table-clumn">
                                        我的-&gt;设置-&gt;隐私管理-&gt;允许通讯录权限访问
                                    </div>
                                    <div className="table-clumn">安卓</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div>
                        <h3>1、iOS系统调用权限说明</h3>
                        <div className="scorll-view">
                            <div className="table1">
                                <div className="table-view">
                                    <div className="table-clumn">设备权限</div>
                                    <div className="table-clumn">
                                        调用权限的目的
                                    </div>
                                    <div className="table-clumn">是否询问</div>
                                    <div className="table-clumn">
                                        用户可否关闭权限
                                    </div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相册</div>
                                    <div className="table-clumn">
                                        帮助您完成扫码充电、实名认证、绑定车辆、维保预约、在线客服和问题反馈、上传头像功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相机</div>
                                    <div className="table-clumn">
                                        帮助您完成扫码充电、实名认证、绑定车辆、维保预约、在线客服和问题反馈、二维码扫描、上传头像功能、扫车牌下单
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">位置</div>
                                    <div className="table-clumn">
                                        帮助您查询附近电站、甲醇站、服务站、运营商、维保预约、年审预约功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <h3>2、Android系统调用权限说明</h3>
                        <div className="scorll-view">
                            <div className="table1">
                                <div className="table-view">
                                    <div className="table-clumn">设备权限</div>
                                    <div className="table-clumn">
                                        调用权限的目的
                                    </div>
                                    <div className="table-clumn">是否询问</div>
                                    <div className="table-clumn">
                                        用户可否关闭权限
                                    </div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">
                                        读取及写入存储器
                                    </div>
                                    <div className="table-clumn">
                                        存储和使用本产品相关目录下产品服务时需要的文档和数据资料，保障产品的正常运行；APP更新升级、文件存储。{" "}
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相机</div>
                                    <div className="table-clumn">
                                        帮助您完成扫码充电、实名认证、绑定车辆、维保预约、在线客服和问题反馈、二维码扫描、上传头像功能、扫车牌下单
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">位置</div>
                                    <div className="table-clumn">
                                        帮助您查询附近电站、甲醇站、服务站、运营商、维保预约、年审预约功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相册</div>
                                    <div className="table-clumn">
                                        帮助您完成扫码充电、实名认证、绑定车辆、维保预约、在线客服和问题反馈、上传头像功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">通知</div>
                                    <div className="table-clumn">
                                        接收充值、充电、消息、年审、保险或其它消息
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">传感器</div>
                                    <div className="table-clumn">
                                        可通过设备的陀螺仪传感器和加速度传感器提供摇一摇活动功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <h3>3、小程序调用权限说明</h3>
                        <div className="scorll-view">
                            <div className="table1">
                                <div className="table-view">
                                    <div className="table-clumn">设备权限</div>
                                    <div className="table-clumn">
                                        调用权限的目的
                                    </div>
                                    <div className="table-clumn">是否询问</div>
                                    <div className="table-clumn">
                                        用户可否关闭权限
                                    </div>
                                </div>

                                <div className="table-view">
                                    <div className="table-clumn">相册</div>
                                    <div className="table-clumn">
                                        帮助您完成绑车、扫码充电功能{" "}
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相机</div>
                                    <div className="table-clumn">
                                        帮助您完成绑车、扫码充电功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">位置</div>
                                    <div className="table-clumn">
                                        帮助您注册时确定您所在城市，更好的提供用车服务
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <h3>4、HarmonyOS系统调用权限说明</h3>
                        <div className="scorll-view">
                            <div className="table1">
                                <div className="table-view">
                                    <div className="table-clumn">设备权限</div>
                                    <div className="table-clumn">
                                        调用权限的目的
                                    </div>
                                    <div className="table-clumn">是否询问</div>
                                    <div className="table-clumn">
                                        用户可否关闭权限
                                    </div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">相机</div>
                                    <div className="table-clumn">
                                        帮助您完成扫码充电、二维码扫描、拍照上传功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                                <div className="table-view">
                                    <div className="table-clumn">位置</div>
                                    <div className="table-clumn">
                                        帮助您查询附近电站、服务站、服务预约功能
                                    </div>
                                    <div className="table-clumn">是</div>
                                    <div className="table-clumn">是</div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </article>
            </div>
        );
    }
}

export default permissionDescribe;



// WEBPACK FOOTER //
// ./src/staticPage/permissionDescribe/index.js